export type Paths = Record<string, string>;
export type Params = Record<string, string | undefined>;

export const buildPaths = <P extends Paths>(paths: P, params: Params): P =>
  Object.entries(paths).reduce(
    (acc, [key, value]) => ({
      ...acc,
      [key]: Object.entries(params).reduce(
        (path, [paramKey, paramValue]) =>
          paramValue ? path.replace(`:${paramKey}`, paramValue) : path,
        value,
      ),
    }),
    {} as P,
  );
